var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBugColourful(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8F9BB3",
    d: "M16.414 6.375h-8.75a4.376 4.376 0 018.751 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4350F7",
    d: "M22 13.285c-.019.681-.595 1.215-1.276 1.215h-2.162v.625a5.6 5.6 0 01-.53 2.388l2.352 2.353a1.25 1.25 0 01-1.768 1.768l-2.138-2.138a5.599 5.599 0 01-3.54 1.254v-9.531c0-.26-.21-.469-.47-.469h-.937a.468.468 0 00-.468.469v9.531a5.602 5.602 0 01-3.541-1.254l-2.138 2.138a1.25 1.25 0 01-1.768-1.768l2.353-2.353a5.583 5.583 0 01-.531-2.388V14.5H3.276c-.681 0-1.257-.534-1.276-1.215A1.25 1.25 0 013.214 12h2.224V9.705L3.616 7.884a1.25 1.25 0 011.768-1.768L7.518 8.25h8.964l2.134-2.134a1.25 1.25 0 011.768 1.768l-1.821 1.821V12h2.187c.69 0 1.25.56 1.25 1.25v.035z"
  }))));
}

export default SvgBugColourful;